import { Controller, useFormContext } from 'react-hook-form'
import { TextField } from '@mui/material'
import { PatchQuotation } from '@/types'

export type QuotationNoteFormData = Pick<PatchQuotation, 'note'>

export const QuotationNoteForm = (): JSX.Element => {
  const { control } = useFormContext<QuotationNoteFormData>()

  return (
    <Controller
      name="note"
      control={control}
      render={({ field }) => (
        <TextField {...field} fullWidth={true} multiline={true} minRows={3} />
      )}
    />
  )
}
